$(document).ready(function(){
    initSwitchGrid();
    initFixedSubMenuOnScrollFW20();
});

function initSwitchGrid() {
    if ($('#large').length <= 0 || $('#small').length <= 0) return;
    const large = $('#large');
    const small = $('#small');
    large.on('click', function () {
        small.removeClass('active');
        $(this).addClass('active');
        $('.fw20__images-grid__content').removeClass('small').addClass('large');
    });
    small.on('click', function () {
        large.removeClass('active');
        $(this).addClass('active');
        $('.fw20__images-grid__content').removeClass('large').addClass('small');
    });
}

function initFixedSubMenuOnScrollFW20() {
    if ($('.fw20__header').length <= 0) {
        return;
    }
    var distance = $('.fw20__header').offset().top;
    if ($(window).scrollTop() > 0) {
        $('.fw20__header').addClass("affix");
    } else {
        $('.fw20__header').removeClass("affix");
    }

    $(window).scroll(function () {
        if ($(window).scrollTop() >= distance) {
            $('.fw20__header').addClass("affix");
        } else {
            $('.fw20__header').removeClass("affix");
        }
    });
}
